module.exports = __webpack_public_path__ + "static/media/CraftsmanshipWithFlair.995df44a.png";